import { Typography, TypographyProps } from '@mui/material';
import React from 'react';

export const HeaderText = React.forwardRef<HTMLSpanElement, TypographyProps<'span', { children: React.ReactNode }>>(
  ({ children, ...properties }, reference) => {
    return (
      <Typography
        ref={reference}
        {...properties}
        variant='subtitle2'
        data-testid='header-text'
        sx={{
          color: 'text.primary',
          fontFeatureSettings: 'normal',
          fontKerning: 'auto',
          fontOpticalSizing: 'auto',
          fontSize: '14px',
          fontSizeAdjust: 'none',
          fontStretch: '100%',
          fontStyle: 'normal',
          fontVariantAlternates: 'normal',
          fontVariantCaps: 'normal',
          fontVariantEastAsian: 'normal',
          fontVariantEmoji: 'normal',
          fontVariantLigatures: 'normal',
          fontVariantNumeric: 'normal',
          fontVariantPosition: 'normal',
          fontVariationSettings: 'normal',
          fontWeight: '500',
          ...properties.sx,
        }}
      >
        {children}
      </Typography>
    );
  }
);

HeaderText.displayName = 'HeaderText';
